import { Component, OnInit,Input ,Output,EventEmitter} from '@angular/core';
import * as moment from 'moment';
import { PlanCalendarService } from 'src/app/Module/Core/PlanCalendar/PlanCalendar.service';
import { environment } from 'src/environments/environment';
import { CommonapiService } from '../../../Service/Commonapi.service';
@Component({
  selector: 'app-CTPlanMove',
  templateUrl: './CTPlanMove.component.html'
})
export class CTPlanMoveComponent implements OnInit {
  @Input() state: any; @Input() data: any;
  @Input() movereasonList=[];
  todayDate: any = new Date();
  minDate: Date = new Date();
  maxDate: any = "";
  @Output() CallParent: EventEmitter<any> = new EventEmitter();
  constructor( private Winfoapi: CommonapiService,private planCalendarapi: PlanCalendarService) { }

  ngOnInit() {
  }
  show=false;
  Show(state){
    this.state.fromDate.value= moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
    this.state.movereason.value = "0";
	  this.state.fromDate.iserr = false; 
    this.state.fromDate.err_txt = "";
    this.state.movereason.iserr = false; 
    this.state.movereason.err_txt = "";
    this.state.movereasonComments.value = "";
    this.show=true;
  }
  planmoveReasonCancel() {
    this.state.movereasonComments.iserr = false;
    this.state.movereasonComments.err_txt = "";
    //$('#divPlanMoveCalendarPopup').removeClass('pop_active_card');
    this.show=false;
    this.Callparentfunc(0);
  }
  Callparentfunc(status,data=''){
    this.CallParent.emit({status:status,data:data});
  }
  Callopen_cal(pic) {
    setTimeout(() => { pic.open() }, 100);
  }
  drpmovereason_Click() {
    if (this.state.movereason.value == '' || this.state.movereason.value == '0') {
      //this.state.movereason.iserr = true; 
      //this.state.movereason.err_txt = "Select reason";

    }
    else {
      this.state.movereason.iserr = false;
      this.state.movereason.err_txt = "";
    }

    this.state.movereasonComments.iserr = false;
    this.state.movereasonComments.err_txt = "";

  }

  async planMoveReasonYes() {
    let isvalid = true;

    if ((this.state.fromDate.value) == "") {

      this.state.fromDate.iserr = true;
      this.state.fromDate.err_txt = "Select date";
      isvalid = false;

    } else if ((this.state.fromDate.value) != "") {
      let movecalendarviewdate = this.state.fromDate.value;
      console.log('movecalendarviewdate', movecalendarviewdate);
      let formatteddayformat =   moment(movecalendarviewdate).format("dddd");
      console.log('formatteddayformat', formatteddayformat);
      let formatteddayformatsting = formatteddayformat.toString();
    
      if (formatteddayformatsting.substring(0, 3) === "Sun") {
        
        this.state.fromDate.iserr = true; 
        this.state.fromDate.err_txt = "Please select other than sunday";
        this.state.fromDate.value = '';
        $('#movecalendarviewdate').val('');
        isvalid = false;
      }
      else{
      this.state.fromDate.iserr = false;
      this.state.fromDate.err_txt = "";
      }
    }

    if ((this.state.movereason.value) == "0") {

      this.state.movereason.iserr = true;
      this.state.movereason.err_txt = "Enter reason";
      isvalid = false;

    } else if ((this.state.movereason.value) != "0") {
      this.state.movereason.iserr = false;
      this.state.movereason.err_txt = "";
    }

    let otherMoveReasonID = '-1';
    this.movereasonList.map((x, index) => {

      if (x.reason == 'Other' || x.reason == 'other') {
        otherMoveReasonID = x.reason_id;

      }
    })

    if ((this.state.movereason.value == otherMoveReasonID) && this.state.movereasonComments.value == '') {
      this.state.movereasonComments.iserr = true;
      this.state.movereasonComments.err_txt = "Enter reason comment";
      isvalid = false;
    }
    else {
      this.state.movereasonComments.iserr = false;
      this.state.movereasonComments.err_txt = "";
    }

    if (isvalid) {
      $('#divPlanMoveCalendarPopup').removeClass('pop_active_card');

      console.log('selected obj', this.data);

      const format1 = "YYYY-MM-DD";
      let calenderDate = moment(this.data.calendar_date).format(format1)

      let currentDate = new Date();
      const currentDateFormat1 = "YYYY-MM-DD";//"DD MMMM YYYY";
      var formattedCurrentDate = moment(currentDate).format(currentDateFormat1);
      var title = "\"" + this.data.customer_name + "\"" + " has been moved by User";      
      //var moveddate = moment(this.state.fromDate.value).format(currentDateFormat1);
      var movedformattedCurrentDate = moment(this.state.fromDate.value).format("YYYY-MM-DD HH:mm:ss")
      var moveddate = movedformattedCurrentDate;
      var postdata = {

        "planId": this.data.plan_id,
        "calendarDate": calenderDate,
        "customerId": this.data.customer_id,
        "movedToDate": moveddate,
        "planAlongStatusSub": "4",
        "reasonId": this.state.movereason.value,
        "reason": this.state.movereasonComments.value,
        "title": title,
        "data": "",
        "isRead": "",
        "url": environment.angularurl + "#/user/planlist",
        "create_user": this.data.is_create_user,
        "presentMonth": this.data.presentMonth,
        "presentYear": this.data.presentYear,
        "preNextFlag": this.data.preNextFlag,
        "latitude": this.data.mainlatitude+"",
        "longitude": this.data.mainlongitude+"",
        "startDate": this.data.startDate,
      }

      console.log("postdata", postdata);
      //return false;

      this.planCalendarapi.api.loader.startLoading();
      this.planCalendarapi.PlanListEventGetUpdateV1(postdata, false).then(data => {

        if (data && data != undefined && data != '[]') {
          console.log('PlanListEventGetUpdateV1',data);
          if (data.planEventUpdateResponse.plan_id > 0) {
            this.state.fromDate.value=""
            this.state.movereason.value = "0";
            this.state.fromDate.iserr = false; 
            this.state.fromDate.err_txt = "";
            this.state.movereason.iserr = false; 
            this.state.movereason.err_txt = "";
            this.state.movereasonComments.value = "";            
            this.show = false;
            // this.Callparentfunc(1,data.planListViewResponse[0]);
            this.Callparentfunc(1,data);
            
            // this.loopcount = 0;
            // this.state.location = ""; // each time location will be set in state to aviod mismatch lat long
            // this.getLocation();
            // this.Check();

          }

        }

        this.Winfoapi.loader.stopLoading();

        //this.winfoapi.loader.stopLoading();
      })



    }
  }
  FromdateChange1()
  {}
  
  FromdateChange(){
    //this.state.mintodate=this.state.fromDate.value;
     let movecalendarviewdate = this.state.fromDate.value;
    console.log('movecalendarviewdate', movecalendarviewdate);
    let formatteddayformat =   moment(movecalendarviewdate).format("dddd");
    console.log('formatteddayformat', formatteddayformat);
    let formatteddayformatsting = formatteddayformat.toString();
    
    if (formatteddayformatsting.substring(0, 3) === "Sun") {
      
      this.state.fromDate.iserr = true; 
      this.state.fromDate.err_txt = "Please select other than sunday";
      this.state.fromDate.value = '';
      $('#movecalendarviewdate').val('');
    }
    else{
      this.state.fromDate.iserr = false; 
      this.state.fromDate.err_txt = ""; 
    }

  }

}
